import * as Sentry from '@sentry/vue';

export function sendError(err: unknown, msg?: string, extra?: unknown): void {
  if (process.env.NODE_ENV === 'development') {
    console.debug(msg, err);
  }
  Sentry.withScope(scope => {
    scope.setLevel('error');
    if (msg) {
      // using Breadcrumb gives you a better UI
      // extra is still supported for legacy reasons, so Sentry still doesn't deprecate it in this major version.
      scope.addBreadcrumb({
        type: 'error',
        message: msg,
        category: 'error',
      });
    }
    if (extra) {
      scope.setExtra('extra', extra);
    }
    Sentry.captureException(err);
  });
}

export function sendWarning(err: unknown, msg?: string, extra?: unknown): void {
  if (process.env.NODE_ENV === 'development') {
    console.debug(msg, err);
  }
  Sentry.withScope(scope => {
    scope.setLevel('warning');
    if (msg) {
      // using Breadcrumb gives you a better UI
      // extra is still supported for legacy reasons, so Sentry still doesn't deprecate it in this major version.
      scope.addBreadcrumb({
        type: 'warning',
        message: msg,
        category: 'warning',
      });
    }
    if (extra) {
      scope.setExtra('extra', extra);
    }
    Sentry.captureException(err);
  });
}
